const m07Section = {
  id: 'm07',
  name: '2027ScoresheetM07Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM07Sub2Label',
      id: 'm07_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
    {
      scoring: '2027ScoresheetM07Sub3Label',
      belowScoring: '2027ScoresheetM07Sub4Label',
      id: 'm07_scoring_2',
      options: [
        {
          description: '0',
          value: 0
        },
        {
          description: '1',
          value: 1
        },
        {
          description: '2',
          value: 2
        }
      ]
    }
  ]
}

export default m07Section;